import activateSaveRegisterClient from './activateSaveRegisterClient'

export const activateSaveRegisterClientPromise = activateSaveRegisterClient
